import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PostFilter } from 'sdk/hooks/useAllPosts';

interface FeedSliceState {
    postFilter: PostFilter;
}

const initialState: FeedSliceState = {
    postFilter: 'all',
};

const feedSlice = createSlice({
    name: 'feed',
    initialState,
    reducers: {
        setPostFilter: (state, action: PayloadAction<PostFilter>) => {
            state.postFilter = action.payload;
        },
    },
});

export const { setPostFilter } = feedSlice.actions;
export default feedSlice.reducer;